import { GameId } from '@common'
import cx from 'classnames'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import BonusPointsImg from '@/assets/images/storefronts/bonus_points.svg'
import { getShortSlugNotHD } from '@/fixtures/games'

import { ProductTypes } from './constants'
import IDRPointsImg from './idr_points.svg' // not int the assets folder, to be hidden until the ID_REWARDS_ENABLED is true
import { config } from '../../../../../config'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './info.module.scss'

type ProductInfoProps = {
  gameSlug: GameId
  productType?: ProductTypes
}

export const ProductInfo = ({ gameSlug, productType }: ProductInfoProps) => {
  const t = useTranslations()
  const shortSlug = getShortSlugNotHD(gameSlug)
  const body1 = t(`${shortSlug}_products_info_purchases`)
  const body2 = t('products_info_challenges')

  return (
    <div className={cx(styles.info, styles[gameSlug], styles[productType ?? ''])}>
      <StoreTypography tag="h2" style="outlined" textSize="body">
        {t('products_info_points_and_bonuses')}
      </StoreTypography>
      <div className={styles.productInfo}>
        <Image src={BonusPointsImg} alt={body1} />
        <StoreTypography tag="p" textSize="sbody" style="plain" overrideFont="supercellText" lineHeight="normal">
          {body1}
        </StoreTypography>
      </div>
      {config.ID_REWARDS_ENABLED && (
        <div className={styles.productInfo}>
          <Image src={IDRPointsImg} alt={body2} />
          <StoreTypography tag="p" textSize="sbody" style="plain" overrideFont="supercellText" lineHeight="normal">
            {body2}
          </StoreTypography>
        </div>
      )}
    </div>
  )
}

ProductInfo.displayName = 'ProductInfo'
